var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kjfw"},[_c('div',{staticClass:"bg"}),_c('h',[_vm._v("正在努力开发中......")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }